
import { Vue } from "vue-class-component";
export default class HighlightLoading extends Vue {}
